import { format } from 'date-fns';
import PdfMake from 'pdfmake';
import pdfFonts from "pdfmake/build/vfs_fonts";


export function buildPdfDownload(documentTitle, columns, rows) {
  PdfMake.vfs = pdfFonts.pdfMake.vfs;
  const scale = 0.4;
  const offset = 30;
  var documentDefinition = {
    pageSize: 'LETTER',
    pageOrientation: 'landscape',
    pageMargins: [10, 75, 10, 10],
    header: [
      {
        canvas: [
          {
            type: 'polyline',
            lineWidth: 0,
            closePath: true,
            color: '#2B60A0',
            points: [
              { x: 5, y: 0 },
              { x: 35, y: 25 },
              { x: 770, y: 25 },
              { x: 770, y: 0 },
            ],
            absolutePosition: { x: 5, y: 0 },
          },
          {
            type: 'polyline',
            lineWidth: 0,
            closePath: true,
            color: '#EFEEEE',
            points: [
              { x: 40 * scale, y: 40 * scale + offset },
              { x: 40 * scale, y: 110 * scale + offset },
              { x: 240 * scale, y: 110 * scale + offset },
              { x: 240 * scale, y: 40 * scale + offset },
            ],
          },
          {
            type: 'polyline',
            lineWidth: 0,
            closePath: true,
            color: '#EFEEEE',
            points: [
              { x: 242 * scale, y: 40 * scale + offset },
              { x: 242 * scale, y: 110 * scale + offset },
              { x: 272 * scale, y: 110 * scale + offset },
              { x: 272 * scale, y: 40 * scale + offset },
            ],
          },
          ...columns.map((column, index) => {
            return {
              type: 'polyline',
              lineWidth: 0,
              closePath: true,
              color: '#EFEEEE',
              points: [
                { x: (274 + 82 * index) * scale, y: 40 * scale + offset },
                { x: (274 + 82 * index) * scale, y: 110 * scale + offset },
                { x: (354 + 82 * index) * scale, y: 110 * scale + offset },
                { x: (354 + 82 * index) * scale, y: 40 * scale + offset },
              ],
            };
          }),
          {
            type: 'polyline',
            lineWidth: 0,
            closePath: true,
            color: '#EFEEEE',
            points: [
              { x: 356 * scale, y: 40 * scale + offset },
              { x: 356 * scale, y: 110 * scale + offset },
              { x: 436 * scale, y: 110 * scale + offset },
              { x: 436 * scale, y: 40 * scale + offset },
            ],
          },
          {
            type: 'line',
            x1: 40 * scale,
            y1: 40 * scale + offset,
            x2: 240 * scale,
            y2: 85 * scale + offset,
            lineWidth: 3,
            color: 'white',
          },
          {
            type: 'line',
            x1: 40 * scale,
            y1: 85 * scale + offset,
            x2: 240 * scale,
            y2: 85 * scale + offset,
            lineWidth: 3,
            color: 'white',
          },
        ],
      },
      {
        text: `TARIFAS DE ${documentTitle}`,
        absolutePosition: { x: 50, y: 10 },
        color: 'white',
        fontSize: 11,
        bold: true,
      },
      {
        text: 'Destino',
        absolutePosition: { x: 55 * scale, y: 65 * scale + offset },
        color: 'black',
        fontSize: 11 * scale,
        bold: true,
      },
      {
        text: 'Origen',
        absolutePosition: { x: 200 * scale, y: 45 * scale + offset },
        color: 'black',
        fontSize: 11 * scale,
        bold: true,
      },
      {
        text: 'Población',
        absolutePosition: { x: 55 * scale, y: 88 * scale + offset },
        color: 'black',
        fontSize: 11 * scale,
        bold: true,
      },
      {
        text: 'Departamento',
        absolutePosition: { x: 150 * scale, y: 88 * scale + offset },
        color: 'black',
        fontSize: 11 * scale,
        bold: true,
      },
      {
        text: 'Tipo',
        absolutePosition: { x: 247 * scale, y: 55 * scale + offset },
        color: 'black',
        fontSize: 10 * scale,
      },
      {
        text: 'Pob.',
        absolutePosition: { x: 247 * scale, y: 75 * scale + offset },
        color: 'black',
        fontSize: 10 * scale,
      },
      ...columns.map((column, index) => {
        return {
          text: column.label,
          absolutePosition: {
            x: (280 + 82 * index) * scale,
            y: 75 * scale + offset,
          },
          color: 'black',
          fontSize: 10 * scale,
        };
      }),
      {
        text: format(new Date(), 'dd/MM/yyyy'),
        absolutePosition: { x: 700, y: 10 },
        color: 'white',
        fontSize: 11 * scale,
        bold: true,
      },
    ],

    content: [
      {
        layout: 'noBorders',
        absolutePosition: { x: 40 * scale, y: 110 * scale + offset },
        table: {
          headerRows: 0,
          widths: [
            92 * scale,
            75 * scale,
            18 * scale,
            ...columns.map(() => 62 * scale),
          ],
          heights: [20 * scale],
          borders: 'white',

          body: [
            ...rows.map((row, index) => {
              if (index % 2 === 0) {
                return [
                  {
                    text: row[0].destination,
                    margin: [10 * scale, 0 * scale, 0 * scale, 0 * scale],
                    fontSize: 9 * scale,
                  },
                  { text: row[0].destination_state, fontSize: 9 * scale },
                  {
                    text: row[0].destination_poblation_type_merch,
                    fontSize: 9 * scale,
                  },
                  ...columns.map((column) => {
                    const value = row.find((x) => x.origin === column.label)[
                      column.id
                    ];
                    if (column.format) {
                      return {
                        text: `\t\t${column.format(value)}\t\t`,
                        background: symbolsColorsPDF(value),
                        alignment: 'center',
                        fontSize: 9 * scale,
                      };
                    } else {
                      return {
                        text: `\t\t${value}\t\t`,
                        background: symbolsColorsPDF(value),
                        alignment: 'center',
                        fontSize: 9 * scale,
                      };
                    }
                  }),
                ];
              } else {
                return [
                  {
                    text: row[0].destination,
                    margin: [10 * scale, 0 * scale, 0 * scale, 0 * scale],
                    fillColor: '#EFEEEE',
                    fontSize: 9 * scale,
                  },
                  {
                    text: row[0].destination_state,
                    fillColor: '#EFEEEE',
                    fontSize: 9 * scale,
                  },
                  {
                    text: row[0].destination_poblation_type_merch,
                    fillColor: '#EFEEEE',
                    fontSize: 9 * scale,
                  },
                  ...columns.map((column) => {
                    const value = row.find((x) => x.origin === column.label)[
                      column.id
                    ];
                    if (column.format) {
                      return {
                        text: `\t\t${column.format(value)}\t\t`,
                        background: symbolsColorsPDF(value) || '#EFEEEE',
                        alignment: 'center',
                        fontSize: 9 * scale,
                      };
                    } else {
                      return {
                        text: `\t\t${value}\t\t`,
                        background: symbolsColorsPDF(value) || '#EFEEEE',
                        alignment: 'center',
                        fontSize: 9 * scale,
                      };
                    }
                  }),
                ];
              }
            }),
          ],
        },
      },
    ],
  };
  PdfMake.createPdf(documentDefinition).download(
    `tarifas_coordinadora_${format(new Date(), 'yyyyMMddHHmmss')}.pdf`
  );
}

export function symbolsColorsPDF(value) {
  if (value === 'L') {
    return '#A68ABB';
  }
  if (value === 'R') {
    return '#ABB94E';
  }
  if (value === 'N') {
    return '#0060A7';
  }
  if (value === 'Z') {
    return '#89C4EA';
  }
  if (value === 'O') {
    return '#B7AE9A';
  }
  if (value === 'E') {
    return '#E9CC1C';
  }

  return false;
}

export function formatValues(value) {
  let numberValue = Number(value);
  if (isNaN(numberValue) || numberValue <= 0) {
    return 'CA';
  } else {
    return `$${numberValue.toLocaleString('es-CO') || 'ERR'}`;
  }
}
